export default __webpack_public_path__ + "static/media/676.f89c51fd.jpg";